// removed by extract-text-webpack-plugin
module.exports = {"Home":"purify_Home__Home___P7faU"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Home/Home.scss
// module id = 286
// module chunks = 0